document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("floatingTrendingProduct");
  const closeBtn = document.querySelector(".floating-close-btn");
  const items = document.querySelectorAll(".floating-product-item");

  if (!popup || items.length === 0) return;

  let currentIndex = 0;
  let interval = null;
  let isPaused = false;

  function showNextProduct() {
    if (isPaused) return;

    popup.classList.remove("is-visible");

    setTimeout(() => {
      items[currentIndex].style.display = "none";
      currentIndex = (currentIndex + 1) % items.length;
      items[currentIndex].style.display = "flex";
      popup.classList.add("is-visible");
    }, 500);
  }

  function startLoop() {
    interval = setInterval(showNextProduct, 5000);
  }

  function stopLoop() {
    clearInterval(interval);
  }

  items.forEach((item, index) => {
    if (index !== 0) item.style.display = "none";
  });

  popup.classList.add("is-visible");
  startLoop();

  popup.addEventListener("mouseenter", function () {
    isPaused = true;
    stopLoop();
  });

  popup.addEventListener("mouseleave", function () {
    isPaused = false;
    startLoop();
  });

  if (closeBtn) {
    closeBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      popup.style.display = "none";
      stopLoop();
    });
  }
});